import React from "react";
import { Inbox } from "lucide-react";
import "./EmptyScreen.css";

function EmptyScreen({
  message = "All caught up",
  subText = "Nothing to show here right now",
  showIcon = true,
  actionLabel,
  onAction,
  compact = false,
  className = "",
}) {
  return (
    <div className={`empty-state${compact ? " empty-state--compact" : ""} ${className}`.trim()} role="status">
      {showIcon && (
        <div className="empty-state__visual" aria-hidden="true">
          <span className="empty-state__dot empty-state__dot--one" />
          <span className="empty-state__dot empty-state__dot--two" />
          <div className="empty-state__icon">
            <Inbox size={34} strokeWidth={1.8} />
          </div>
        </div>
      )}

      <div className="empty-state__content">
        <h3 className="empty-state__title">{message}</h3>
        {subText && <p className="empty-state__text">{subText}</p>}
        {actionLabel && onAction && (
          <button className="empty-state__action" type="button" onClick={onAction}>
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
}

export default EmptyScreen;
